import type { MediaFileDTO } from '@/api/generated/model';

// Video detection — port of ContentHeaderMediaCard (doc 08 §2.2, §4.7): fileType in {VIDEO,VID}.
// Mux HLS uses ".m3u8"; pipeline-only admin test uploads skip Mux and use a direct S3 URL.
export function isVideoMedia(m: MediaFileDTO): boolean {
  const t = m.fileType?.toUpperCase();
  if (t !== 'VIDEO' && t !== 'VID') return false;
  return Boolean(m.url);
}
